import { render } from "./infoDetail.vue?vue&type=template&id=fac87584&scoped=true&ts=true"
import script from "./infoDetail.vue?vue&type=script&lang=ts"
export * from "./infoDetail.vue?vue&type=script&lang=ts"

import "./infoDetail.vue?vue&type=style&index=0&id=fac87584&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fac87584"]])

export default __exports__